export default `
    <div id="#= data.id #" class="bind-label # if (data.disabled) { # disabled # } # #: data.classes || "" # #=data.bsc||""#" 
        # if (data.title) {#
             data-bind="text: #= data.title #" 
        # } # 
        # if (data.width) { #
             style="width: #= data.width #px;" 
        # } #
        # if (data.toolTip) { #
             title="#= data.toolTip #" 
        # } # 
    >
    </div>
`;
